var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-box",class:{header:_vm.is_header},on:{"click":_vm.playVideo}},[_c('van-image',{staticClass:"thumb",attrs:{"src":_vm.thumb,"fit":"cover"}}),_vm._v(" "),_c('img',{staticClass:"play",attrs:{"src":require("@/assets/icon/video_100.png")}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d85ed766","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoBox.vue
// module id = null
// module chunks = 